<template>
	<vs-popup class="view-order-task" :title="$t('taskView')" :active.sync="popupActive">
		<div class="body" v-if="task">
			<table>
				<tr>
					<td><b>{{ $t('date') }}</b></td>
					<td>{{ task.date_time | moment("DD.MM.YYYY") }}</td>
				</tr>
				<tr v-if="mode === 'order'">
					<td><b>{{ $t('ticket') }}</b></td>
					<td>
						<router-link :to="'/ticket/' + task.order.id">
							<span @click="popupActive = false">
								№{{ task.order.id }}
							</span>
						</router-link
						>
					</td>
				</tr>
			</table>
			<b>{{ $t('description') }}</b>
			<p>
				{{ task.description }}
			</p>
		</div>
		<div class="footer" v-if="!!task">
			<vs-button
				color="danger"
				:disabled="task.is_by_admin"
				@click="closeTask"
			>{{ task.is_by_admin ? $t('setByAdmin') : $t('delete') }}
			</vs-button>

			<vs-button
				color="success"
				@click="completeTask"
			>{{ $t('done') }}
			</vs-button>
		</div>
	</vs-popup>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "ViewOrderTask",
	mixins: [databaseManager, notifier],
	props: {
		active: { required: true, type: Boolean },
		order: { required: true },
		mode: { type: String, default: "order" }
	},
	data() {
		return {
			task: null,
		}
	},
	watch: {
		order() {
			this.updateTask();
		},
		popupActive(newValue) {
			if(newValue) {
				this.updateTask();
			}
		}
	},
	computed: {
		popupActive: {
			get() {
				return this.active;
			},
			set(newValue) {
				this.$emit("update:active", newValue);
			}
		},
	},
	methods: {
		async updateTask() {
			if(!this.order || !this.order.task) return;

			const task = this.order.task;
			const fullInfo = await this.dbViewTask(task.id);
			this.task = {
				id: task.id,
				order: {id: this.order.id},
				date_time: task.date_time,
				description: task.description,
				is_by_admin: fullInfo.is_by_admin,
			};
		},
		async completeTask() {
			try {
				await this.dbCompleteTask(this.task.id);

				this.notifySuccess(this.$t('completedSuccessfully'));
				this.popupActive = false;
				this.order.task = null;

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async closeTask() {
			try {
				await this.dbCloseTask(this.task.id);

				this.notifySuccess(this.$t('deletedSuccessfully'));
				this.popupActive = false;
				this.order.task = null;

			} catch (e) {
				this.notifyError(e.message);
			}
		},
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";

.view-order-task {
	.vs-popup--title h3 {
		color: $primary;
	}

	.vs-popup--content {
		padding: 0;
	}

	.vs-popup--close {
		color: $primary;
	}

	table {
		width: 100%;

		td {
			padding-bottom: 4px;
		}
	}

	.body {
		padding: 1rem;

		table {
			margin-left: -2px;
		}

		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}

	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;

		button {
			margin-left: 10px;
		}
	}
}
</style>
